import {
  AlarmClock,
  AlertCircle,
  AlertOctagon,
  AlertTriangle,
  Archive,
  ArrowLeft,
  ArrowLeftRight,
  ArrowUpRight,
  Ban,
  BarChart3,
  Bell,
  BellOff,
  BellRing,
  Bookmark,
  BookmarkPlus,
  BookOpen,
  Braces,
  Bug,
  Building,
  Building2,
  Calendar,
  CalendarCheck,
  CalendarClock,
  CalendarDays,
  CalendarX,
  Captions,
  Check,
  CheckCheck,
  CheckCircle,
  ChevronDown,
  ChevronRight,
  ChevronUp,
  Circle,
  CircleCheck,
  CircleDot,
  CircleMinus,
  CirclePause,
  CirclePlay,
  CircleX,
  ClipboardCheck,
  Clock,
  Copy,
  CopyX,
  CreditCard,
  DollarSign,
  Download,
  Ellipsis,
  Equal,
  Eye,
  EyeOff,
  File,
  FilePen,
  FileText,
  Filter,
  Flag,
  Folder,
  FolderOpen,
  GalleryHorizontalEnd,
  Globe,
  GraduationCap,
  GripVertical,
  Headphones,
  History,
  Home,
  Hourglass,
  IdCard,
  Image as ImageIcon,
  Inbox,
  Info,
  Key,
  Keyboard,
  Landmark,
  Layers,
  LayoutDashboard,
  LineChart,
  Link,
  ListChecks,
  Lock,
  LockOpen,
  type LucideIcon,
  Mail,
  MapPin,
  MapPinOff,
  Merge,
  MessageCircle,
  MessageCircleQuestion,
  MessageSquare,
  MessagesSquare,
  Monitor,
  Moon,
  MoreHorizontal,
  MoreVertical,
  MoveRight,
  Package,
  Paperclip,
  PauseCircle,
  Pencil,
  Phone,
  Pin,
  Plane,
  Plug,
  Plus,
  Radar,
  RadioTower,
  Receipt,
  Reply,
  RotateCcw,
  RotateCw,
  Save,
  ScrollText,
  Search,
  SearchX,
  Send,
  Settings,
  Share2,
  ShieldCheck,
  SignalLow,
  SignalMedium,
  Siren,
  SlidersHorizontal,
  Sparkle,
  Sparkles,
  SquareArrowRightExit,
  Star,
  StickyNote,
  Sun,
  Tag,
  Tags,
  TagX,
  Thermometer,
  Trash2,
  TrendingUp,
  TriangleAlert,
  Undo2,
  Unlink,
  Upload,
  User,
  UserCheck,
  UserMinus,
  UserPlus,
  Users,
  UserSearch,
  Wallet,
  WandSparkles,
  Waypoints,
  Workflow,
  Wrench,
  X,
  Zap,
} from 'lucide-react';

/**
 * The lucide icons the app renders, keyed by their lucide name (as published
 * by the library). {@link DynamicIcon} with `library="lucide"` looks a glyph up
 * here by the name you pass — no Material Symbols translation. Add a one-line
 * entry when you need a lucide icon that isn't listed yet.
 */
export const LUCIDE_ICONS: Record<string, LucideIcon> = {
  'alarm-clock': AlarmClock,
  'alert-circle': AlertCircle,
  'alert-octagon': AlertOctagon,
  'alert-triangle': AlertTriangle,
  'arrow-left': ArrowLeft,
  'arrow-left-right': ArrowLeftRight,
  'arrow-up-right': ArrowUpRight,
  archive: Archive,
  ban: Ban,
  'bar-chart-3': BarChart3,
  bell: Bell,
  'bell-off': BellOff,
  'bell-ring': BellRing,
  bookmark: Bookmark,
  'bookmark-plus': BookmarkPlus,
  'book-open': BookOpen,
  braces: Braces,
  bug: Bug,
  building: Building,
  'building-2': Building2,
  calendar: Calendar,
  'calendar-check': CalendarCheck,
  'calendar-clock': CalendarClock,
  'calendar-days': CalendarDays,
  'calendar-x': CalendarX,
  captions: Captions,
  check: Check,
  'check-check': CheckCheck,
  'check-circle': CheckCircle,
  'chevron-down': ChevronDown,
  'chevron-right': ChevronRight,
  'chevron-up': ChevronUp,
  circle: Circle,
  'circle-check': CircleCheck,
  'circle-dot': CircleDot,
  'circle-minus': CircleMinus,
  'circle-pause': CirclePause,
  'circle-play': CirclePlay,
  'circle-x': CircleX,
  'clipboard-check': ClipboardCheck,
  clock: Clock,
  copy: Copy,
  'copy-x': CopyX,
  'credit-card': CreditCard,
  'dollar-sign': DollarSign,
  download: Download,
  ellipsis: Ellipsis,
  equal: Equal,
  eye: Eye,
  'eye-off': EyeOff,
  file: File,
  'file-pen': FilePen,
  'file-text': FileText,
  filter: Filter,
  flag: Flag,
  folder: Folder,
  'folder-open': FolderOpen,
  'gallery-horizontal-end': GalleryHorizontalEnd,
  globe: Globe,
  'graduation-cap': GraduationCap,
  'grip-vertical': GripVertical,
  headphones: Headphones,
  history: History,
  home: Home,
  hourglass: Hourglass,
  'id-card': IdCard,
  image: ImageIcon,
  inbox: Inbox,
  info: Info,
  key: Key,
  keyboard: Keyboard,
  landmark: Landmark,
  layers: Layers,
  'layout-dashboard': LayoutDashboard,
  'line-chart': LineChart,
  link: Link,
  'list-checks': ListChecks,
  lock: Lock,
  'lock-open': LockOpen,
  mail: Mail,
  'map-pin': MapPin,
  'map-pin-off': MapPinOff,
  'message-circle': MessageCircle,
  'message-circle-question': MessageCircleQuestion,
  'message-square': MessageSquare,
  'messages-square': MessagesSquare,
  merge: Merge,
  monitor: Monitor,
  moon: Moon,
  'more-horizontal': MoreHorizontal,
  'more-vertical': MoreVertical,
  'move-right': MoveRight,
  package: Package,
  paperclip: Paperclip,
  'pause-circle': PauseCircle,
  pencil: Pencil,
  phone: Phone,
  pin: Pin,
  plane: Plane,
  plug: Plug,
  plus: Plus,
  radar: Radar,
  'radio-tower': RadioTower,
  receipt: Receipt,
  reply: Reply,
  'rotate-ccw': RotateCcw,
  'rotate-cw': RotateCw,
  save: Save,
  'scroll-text': ScrollText,
  search: Search,
  'search-x': SearchX,
  send: Send,
  settings: Settings,
  'share-2': Share2,
  'shield-check': ShieldCheck,
  'signal-low': SignalLow,
  'signal-medium': SignalMedium,
  siren: Siren,
  'sliders-horizontal': SlidersHorizontal,
  sparkle: Sparkle,
  sparkles: Sparkles,
  'square-arrow-right-exit': SquareArrowRightExit,
  star: Star,
  'sticky-note': StickyNote,
  sun: Sun,
  tag: Tag,
  tags: Tags,
  'tag-x': TagX,
  thermometer: Thermometer,
  'trash-2': Trash2,
  'trending-up': TrendingUp,
  'triangle-alert': TriangleAlert,
  'undo-2': Undo2,
  unlink: Unlink,
  upload: Upload,
  user: User,
  'user-check': UserCheck,
  'user-minus': UserMinus,
  'user-plus': UserPlus,
  'user-search': UserSearch,
  users: Users,
  wallet: Wallet,
  'wand-sparkles': WandSparkles,
  waypoints: Waypoints,
  workflow: Workflow,
  wrench: Wrench,
  x: X,
  zap: Zap,
};

export const resolveLucideIcon = (name?: string): LucideIcon | undefined =>
  name ? LUCIDE_ICONS[name] : undefined;
